var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('LelyLoginView',{attrs:{"credentials":""},on:{"authenticated":function($event){return _vm.login()}}},[_c('div',[_c('h2',{staticClass:"font-weight-normal"},[_vm._v(" Messensetbeheer ")]),_c('h2',{staticClass:"font-weight-light"},[_vm._v(" Inloggen ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }